import React, {Fragment, useState} from 'react'
import {Controller} from "react-hook-form"
import Proptypes from 'prop-types'
import moment from "moment"
//************************************//
import {trans} from '@utils'
//************************************//
import UncontrolledDateTime from "./UncontrolledDateTime"
//************************************//
const DateTime = ({
  name = '',
  control = null,
  defaultValue: defaultValueProp = '',
  className = '',
  placeholder = '',
  size = 'md',
  format = 'L',
  displayFormat = 'L',
  startWithDisplayFormat = '',
  minDate = null,
  maxDate = null,
  opens = 'right',
  enableTime = false,
  allowClear = false,
  // FW-1920 — before the React 19 migration this was `props.displayCalenderIcon`
  // (undefined => icon hidden). The migration defaulted it to `true`, which turned
  // the calendar icon on for every date field across Assignments, Issues and
  // Analytics. Opt-in, not opt-out.
  displayCalenderIcon = false,
  timezone = true,
  drops = 'down',
  cancelLabel = 'gen.actions.cancel',
  applyLabel = 'gen.actions.apply',
  rules = {},
  onChange = () => {},
  onClear = () => {},
  disabled
}) => {
  const [ref, setRef] = useState(null)
  const defaultValue = defaultValueProp
    // ? moment(defaultValueProp).toISOString(true)
    ? moment(defaultValueProp).toISOString(timezone)
    : null
  //************************************//
  return (
    <Controller
      refs={(ref) => setRef(ref)}
      as={UncontrolledDateTime}
      name={name}
      control={control}
      defaultValue={defaultValue}
      className={className}
      placeholder={placeholder}
      size={size}
      format={format}
      disabled={disabled}
      startWithDisplayFormat={startWithDisplayFormat}
      displayFormat={displayFormat}
      minDate={minDate}
      maxDate={maxDate}
      opens={opens}
      enableTime={enableTime}
      allowClear={allowClear}
      displayCalenderIcon={displayCalenderIcon}
      timezone={timezone}
      cancelLabel={trans(cancelLabel)}
      applyLabel={trans(applyLabel)}
      onFocus={() => {
        // console.log(ref)
        // focus on validation
        // focus and close on validation
      }}
      onInputChange={(value) => {
        onChange(value)
      }}
      onClear={(clearProps) => {
        onClear(clearProps)
      }}
      drops={drops}
      rules={rules}
    />
  )
}
//************************************//
DateTime.propTypes = {
  name: Proptypes.string.isRequired,
  control: Proptypes.any,
  defaultValue: Proptypes.any,
  className: Proptypes.string,
  placeholder: Proptypes.string,
  size: Proptypes.string,
  format: Proptypes.string,
  displayFormat: Proptypes.string,
  startWithDisplayFormat: Proptypes.string,
  minDate: Proptypes.string,
  maxDate: Proptypes.string,
  opens: Proptypes.string, 
  enableTime: Proptypes.bool,
  allowClear: Proptypes.bool,
  timezone: Proptypes.bool,
  drops: Proptypes.string,
  cancelLabel: Proptypes.string,
  applyLabel: Proptypes.string,
  rules: Proptypes.object,
  onChange: Proptypes.func,
  onClear: Proptypes.func
}
//************************************//
export default DateTime
